import { documentsApiRef } from '@agilelab/plugin-wb-builder-catalog';
import {
  WitboostDocument,
  WitboostDocumentWithAcceptanceDate,
} from '@agilelab/plugin-wb-documents-common';
import {
  WbCard,
  WbTable,
  customAlertApiRef,
} from '@agilelab/plugin-wb-platform';
import { useApi } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';
import { useDocumentsTabColumns } from './useDocumentsTabColumns';

export interface DocumentsTableSort {
  field?: keyof WitboostDocument;
  direction?: 'asc' | 'desc';
}

export const DocumentsViewerTab = () => {
  const documentsApi = useApi(documentsApiRef);
  const alertApi = useApi(customAlertApiRef);
  const documentsColumns = useDocumentsTabColumns();
  const [documents, setDocuments] = useState<
    WitboostDocumentWithAcceptanceDate[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedDocuments = await documentsApi.retrieveDocuments({
        enabled_only: true,
        metadata_only: true,
        include_acceptance_date: true,
      });

      setDocuments(fetchedDocuments);
    };

    try {
      fetchData();
    } catch (error) {
      alertApi.post({
        error: error,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  }, [documentsApi, alertApi]);

  return (
    <WbCard title="My Documents">
      <WbTable<WitboostDocument>
        components={{
          tableLoader: { loading },
          tableContent: {
            columns: documentsColumns,
            rows: documents,
          },
        }}
      />
    </WbCard>
  );
};
